export enum BroadcastMessageType {
	SessionTimmerExtended = 'SessionTimmerExtended',
	SessionTimmerExpired = 'SessionTimmerExpired',
	SessionTimmerNotExtended = 'SessionTimmerNotExtended',
	SessionTimmerNotExtendedDueTokenRefreshError = 'SessionTimmerNotExtendedDueTokenRefreshError',
	SessionKilled = 'SessionKilled',
	SessionProfileSwitched = 'SessionProfileSwitched',
}
